import { render, staticRenderFns } from "./WarningColorIcon.vue?vue&type=template&id=4e499465&"
import script from "./WarningColorIcon.vue?vue&type=script&lang=js&"
export * from "./WarningColorIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports